export default __webpack_public_path__ + "static/media/slow_mo_transition_notes.55a634dd.jpg";